function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "ic_increase",
  transform: "translate(0.459)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 18,
  height: 18,
  transform: "translate(-0.459)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_31",
  "data-name": "Group 31",
  transform: "translate(3 5.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M0,7.047,3.507,3.438,6.2,5.929,11.493,0",
  transform: "translate(0 0)",
  fill: "none",
  stroke: "#1dbf73",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_7",
  "data-name": "Line 7",
  d: "M3,.5H0",
  transform: "translate(8.493 -0.5)",
  fill: "none",
  stroke: "#1dbf73",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  id: "Line_7-2",
  "data-name": "Line 7",
  d: "M.5,0V3",
  transform: "translate(10.993)",
  fill: "none",
  stroke: "#1dbf73",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
})));

function SvgIcIncrease(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIncrease);
export default __webpack_public_path__ + "static/media/ic_increase.07730473.svg";
export { ForwardRef as ReactComponent };